import { action, Action } from 'typesafe-actions'

import { ValidaTypes, PayloadAutorizacao } from './types'

export const setLoading = (payload: boolean): Action =>
  action(ValidaTypes.VALIDA_SET_LOADING, payload)

export const postIsafeAutorizacao = (payload: PayloadAutorizacao): Action =>
  action(ValidaTypes.POST_ISAFE_AUTORIZACAO, payload)
